export default "__VITE_ASSET__BIK$d_GU__"